import React, { useState } from 'react';
import AnalyseCalc from './components/AnalyseCalc';
import { HashRouter, Link, NavLink, Route, Routes } from 'react-router';
import Violations from './components/Violations';
import BalanceCalc from './components/BalanceCalc';
import TiA from './components/TiA';



function App() {

  return (
    <HashRouter>
      <section className="calc">
          <div className="container-fluid position-relative">
              <div className="bg-regal-blue">
                  <div className="row pt-3 pb-1 sm-pt-40px">
                      <div className="col calc-nav">
                          <div className="calc-nav-flex">
                              <NavLink to={"/analiza-ryzyka"}>Analiza ryzyka</NavLink>
                              <NavLink to={"/waga-naruszen"}>Waga naruszen</NavLink>
                              <NavLink to={"/test-rownowagi"}>Test rownowagi</NavLink>
                              <NavLink to={"/tia"}>TiA</NavLink>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <section style={{"paddingTop": "5px !important"}}>
          <div className="container-lg position-relative">
            <div className="row align-items-center">
                <div className="col pb-35px md-pb-0 text-dark-gray border-color-extra-medium-gray sm-border-end-0">
                    <Routes>
                      <Route path="/" element={<AnalyseCalc />} />
                      <Route path="/analiza-ryzyka" element={<AnalyseCalc />} />
                      <Route path='/waga-naruszen' element={<Violations />} />
                      <Route path='/test-rownowagi' element={<BalanceCalc />} />
                      <Route path='/tia' element={<TiA />} />
                    </Routes>
                </div>
              </div>
          </div>
      </section>
    </HashRouter>
  );
}

export default App;
